import {
  Box,
  Container,
  VStack,
  HStack,
  Text,
  Flex,
  Image,
} from "@chakra-ui/react";
import LoginForm from "../components/Login/LoginForm";
import CMSIcon from "../assets/icons/cms-icon.png";
import PoweredByTechUnicorn from "../assets/images/powered-by-techunicorn.png";
import AuthFormSideImage from "../assets/images/auth-form-side-image.jpg";
import LanguageSelector from "../components/ui/LanguageSelector";

const Login = () => {
  return (
    <Flex direction={{ base: "column", lg: "row" }} h="100vh" overflow="hidden">
      {/* Left Side - Login Form */}
      <Box
        flex="1"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        bg="white"
        p={8}
        overflowY="auto"
        maxH={{ base: "auto", lg: "100vh" }}
      >
        {/* Language Selector */}
        <HStack justify="flex-end" w="full">
          <LanguageSelector />
        </HStack>
        <Container maxW="md" w="full">
          <VStack gap={4} align="stretch" w={"full"}>
            {/* Logo Section - Placeholder for user to upload */}
            <VStack>
              <Box
                w="120px"
                h="120px"
                borderRadius="full"
                bg="gray.100"
                display="flex"
                alignItems="center"
                justifyContent="center"
                border="2px solid"
                borderColor="gray.200"
              >
                <Image src={CMSIcon} alt="CMS Icon" w="100%" h="100%" />
              </Box>
            </VStack>

            {/* Title and Subtitle */}
            <VStack gap={2} align="stretch">
              <Text
                fontSize="30px"
                fontWeight="700"
                textAlign="center"
                lineHeight="133%"
              >
                Collaborative Courts CMS
              </Text>
              <Text
                fontSize="sm"
                color="gray.600"
                textAlign="center"
                lineHeight="150%"
              >
                Welcome back! Please enter your details.
              </Text>
            </VStack>

            {/* Login Form */}
            <LoginForm />

            {/* Footer */}
            <VStack gap={1} pt={"100px"}>
              <Image
                src={PoweredByTechUnicorn}
                alt="Powered by Tech Unicorn"
                height={"1.3rem"}
                width={"auto"}
              />
            </VStack>
          </VStack>
        </Container>
      </Box>

      {/* Right Side - Building Image */}
      <Box
        flex="1"
        display={{ base: "none", lg: "block" }}
        w="100%"
        h={{ base: "auto", lg: "100vh" }}
        overflow="hidden"
        position="relative"
      >
        <Image
          src={AuthFormSideImage}
          alt="Auth Form Side Image"
          objectFit="cover"
          w="100%"
          h="100%"
          borderRadius="20px"
        />
      </Box>
    </Flex>
  );
};

export default Login;
